// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1236":"189cc948","5515":"bf9f21d1","8796":"ef3cc8cb","9742":"33a6aff9"}[chunkId] + ".chunk.css";
};